import axios from "@/plugins/axios";
import { UserIdentity } from "@/utils/constants";
import * as utils from "@/utils/index";
import _ from "lodash";
import userApi from "@/network/api/account/user";
import groupApi from "@/network/api/group/index";
import Toast from "@/utils/toast";
import router from "@/router";
export type UserState = {
  auth_token: string;
  sys: string;
  userInfo: any;
  groupInfo: any;
  group_id: "";
  groupList: any[];
  corporationList: any[];
  anchorInfo: any;
};

export default {
  namespaced: true,
  state: {
    auth_token: "",
    sys: "",
    userInfo: {},
    groupList: [],
    group_id: "",
    corporationList: [],
    anchorInfo: {},
  },
  getters: {
    // 是否是渠道商客户
    isChannelUser(state) {
      if (utils.isChannelDomain()) {
        return true;
      }

      const channelArray = ["qiniu"];
      if (channelArray.includes(state.userInfo.channel_no)) {
        return true;
      } else {
        return false;
      }
    },

    //是否是管理员
    isPower(state) {
      if (state.groupInfo) {
        return state.groupInfo.account_type === "" ? false : true;
      } else {
        return false;
      }
    },
    //判断是否集团账号
    isGroup(state) {
      if (state.group_id) {
        return true;
      } else {
        return false;
      }
    },
    //判断是否还是集团会员
    isGroupVip(state) {
      if (state.group_id && [1, 2, 3, 4].includes(state.groupInfo.level_id)) {
        if (new Date().getTime() > state.groupInfo.expired_at * 1000) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    // 个人登录是否拒绝
    personIsReject(state) {
      return !["", "success", "apply"].includes(state.userInfo.status);
    },
    // 企业登录是否拒绝
    companyIsReject(state) {
      return !["", "success", "apply"].includes(state.userInfo.corp_status);
    },
    // 是否被拒绝
    isReject(state, getters) {
      return (
        (state.userInfo.status !== "success" &&
          state.userInfo.status !== "apply" &&
          getters.companyIsReject) ||
        (state.userInfo.corp_status !== "success" &&
          state.userInfo.corp_status !== "apply" &&
          getters.personIsReject)
      );
    },

    //集团子账号
    userList(state) {
      const temp = state.groupList
        .filter((item) => {
          return item.userid != state.userInfo.userid;
        })
        .map((item) => {
          return {
            value: item.userid,
            label: item.userid == state.userInfo.userid ? "我的" : item.username || "暂无昵称",
          };
        });
      temp.unshift({
        value: state.userInfo.userid,
        label: "我的",
      });
      temp.unshift({
        value: "",
        label: "全部成员",
      });
      return temp;
    },
    identity(state) {
      let corporationIdentity;
      if (state.groupInfo && !_.isEqual(state.groupInfo, {})) {
        const account_type = state.groupInfo.account_type;
        switch (account_type) {
          case "":
            corporationIdentity = UserIdentity.Member;
            break;
          case "admin":
            corporationIdentity = UserIdentity.Admin;
            break;
          case "own":
            corporationIdentity = UserIdentity.Owner;
            break;
          default:
            corporationIdentity = UserIdentity.Member;
        }
        return corporationIdentity;
      } else {
        return UserIdentity.Known;
      }
    },

    duration(state) {
      return state.group_id ? state.groupInfo.remain_duration : state.userInfo.remain_duration;
    },

    level(state) {
      return state.group_id ? state.groupInfo.level_id : state.userInfo.level_id;
    },
  },
  mutations: {
    SAVE_AUTH_TOKEN(state, payload: { token: string; sys: string }) {
      state.auth_token = payload.token;
      state.sys = payload.sys;
      axios.defaults.headers.common = {
        Authorization: payload.token,
      };
      const d = new Date();
      d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
      const expires = "expires=" + d.toUTCString();
      const cname = "auth_token";
      if (!process.env.VUE_APP_ENV) {
        document.cookie = cname + "=" + payload.token + ";" + expires;
      } else {
        document.cookie =
          cname + "=" + payload.token + ";" + expires + ";path=/;domain=.metamaker.cn";
      }
      localStorage.sys = payload.sys;
    },
    REMOVE_GROUP_INFO(state) {
      state.groupInfo = {};
      state.group_id = "";
      localStorage.removeItem("groupInfo");
      localStorage.removeItem("group_id");
    },
    SAVE_GROUP_LIST(state, list) {
      state.groupList = list;
    },
    SAVE_CORPORATION_LIST(state, list) {
      state.corporationList = list;
    },
    SAVE_USER_INFO(state, userInfo) {
      if (
        ((userInfo.account_prop == "person" && userInfo.created_at < 1647878400) ||
          userInfo.account_prop == "corporation") &&
        userInfo.level_id > 0 &&
        userInfo.level_info.is_render == 1
      ) {
        userInfo.exportAccess = true;
      }

      state.userInfo = userInfo;
      localStorage.userInfo = JSON.stringify(userInfo);
    },
    SAVE_ANCHOR_NUM(state, data) {
      state.anchorInfo = data;
    },
  },
  actions: {
    getUserInfo({ commit, dispatch }) {
      // const level_id = state.userInfo.level_id;
      return userApi
        .getInfo()
        .then((data) => {
          commit("SAVE_USER_INFO", data.user_base);
        })
        .catch((res) => {
          if (res.err_code == -15000) {
            Toast.error(res.err_msg);
            throw new Error(res.err_msg);
          }
          if (res.err_code === -10028) {
            dispatch("logout", false);
            Toast.error("用户信息已过期，请重新登录。");
          }
        });
    },

    refreshAuthToken({ commit, dispatch, state }) {
      userApi
        .refreshToken({
          group_id: state.group_id,
        })
        .then((data) => {
          commit("user/SAVE_AUTH_TOKEN", { token: data, sys: localStorage.sys }, { root: true });
          dispatch("getUserInfo");
        });
    },
    judgeIsGroup() {
      // 如果是集团账号

      return new Promise((resolve, reject) => {
        groupApi
          .getList()
          .then((res) => {
            if (res.length) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch((err) => {
            Toast.error(err.err_msg);
            reject(err);
          });
      });
    },
    getGroupUse({ commit }) {
      groupApi
        .accountList({
          page_index: 1,
          page_size: 400,
          created_at_order: "desc",
        })
        .then((data) => {
          commit("SAVE_GROUP_LIST", data.list);
        });
    },
    getGroupInfo({ commit, dispatch }) {
      return groupApi.getList().then((data) => {
        if (data.length) {
          commit("SAVE_CORPORATION_LIST", data);
          const id = localStorage.getItem("group_id");
          const groupInfo = data.find((v) => v.id == id);
          if (!groupInfo) {
            return;
          }
          commit("REMOVE_GROUP_INFO", groupInfo);
          dispatch("getAnchorNum");
          if (groupInfo.account_type) {
            dispatch("getGroupUse");
          }
        }
      });
    },
    logout({ commit }, isRedirectToHome = true) {
      commit("SAVE_AUTH_TOKEN", { token: "" });
      commit("SAVE_USER_INFO", {});
      const expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
      const cname = "auth_token";

      // if (!process.env.VUE_APP_ENV) {
      //   document.cookie = cname + "=" + "payload.token" + ";" + expires;
      // } else {
      //   document.cookie =
      //     cname + "=" + "payload.token" + ";" + expires + ";path=/;domain=.metamaker.cn";
      // }

      if (isRedirectToHome) {
        router.replace("/home");
      }
    },
    async getAnchorNum({ commit }) {
      await groupApi.getAnchorNum().then((res) => {
        commit("SAVE_ANCHOR_NUM", res);
      });
    },
  },
};
